import { Components, listItemButtonClasses, Theme } from '@mui/material';

export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          '&:hover': {
            backgroundColor: theme.palette.background.surface.hover,
          },
          [`&.${listItemButtonClasses.selected}`]: {
            backgroundColor: theme.palette.background.surface.selected,
          },
          [`&.${listItemButtonClasses.selected}:hover`]: {
            backgroundColor: theme.palette.background.surface.hover,
          },
        };
      }

      return {};
    },
  },
};
